export class VobAssignmentAddCommand {
    upn: string;
    assignments: VobAssignmentDto[];

    constructor(upn: string, assignments: VobAssignmentDto[]) {
        this.upn = upn;
        this.assignments = assignments;
    }
}

export class VobAssignmentDto {
    assignmentValues: string[];
    assignmentType: string;
    processType: string;

    constructor(assignmentValues: string[], assignmentType: string, processType: string) {
        this.assignmentValues = assignmentValues;
        this.assignmentType = assignmentType;
        this.processType = processType;
    }
}
